import axios from 'axios';
const Api = {
    makeCall(httpMethod, endpoint, payload, useToken, callDone, callFail) {
        httpMethod = httpMethod.toLowerCase();
        if (httpMethod === 'post' || httpMethod === 'put' || httpMethod === 'patch') {

            //const options = {
            //    method: httpMethod,
            //    headers: { 'Content-Type': 'application/json', },
            //    data: JSON.stringify(payload),
            //    url: application.apiUrl + endpoint,
            //};
            //axios(options).then((response) => {
            //    callDone(response);
            //}).catch(error => {
            //    callFail(error);
            //});
            //return axios.post(application.apiUrl + endpoint, JSON.stringify(payload),
            return axios[httpMethod](process.env.REACT_APP_API_URL + endpoint, JSON.stringify(payload),
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            //post: { 'Access-Control-Allow-Origin': '*' },
                        },
                    })
                .then((response) => {
                    callDone(response);
                }).catch(error => {
                    if(callFail)
                        callFail(error);
                });
        } else {

            return axios.get(process.env.REACT_APP_API_URL + endpoint,

          //  return axios[httpMethod](application.apiUrl + endpoint,
                    {
                        headers: {
                            post: { 'Access-Control-Allow-Origin': '*' },
                            //culture: culture,
                            //Authorization: application.authorization,
                        },
                    })
                .then((response) => {
                    callDone(response);
                }).catch(error => {
                    if(callFail)
                        callFail(error);
                });
        }

    }
}

export default Api;